// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a4","content":"a5","header":"a6","message":"a7","iframeWrapper":"a8"};